import type { Readable } from "node:stream";
import type { SidecarWebhookCommands } from "./sidecars-server/SidecarWebhookCommands";
import type { TuvisMessageSource } from "./incident/source";

export type WithRequired<T, K extends keyof T> = T & { [P in K]-?: T[P] };

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type PartialRecord<K extends keyof any, T> = {
  [P in K]?: T;
};

export const RELATE_OPP_FIELD_NAME = "whatsllySfdcRelatedOpp";

export interface MediaStreamHandlerI {
  createStream(): Promise<Readable>;
}

export type StreamMediaToIngestOptions = {
  webhook?: string;
  ingestUrl?: string;
  orgId: string;
  sourcePhone: string;
  sourceId: string;
  sourceUid: string;
  reqId: string;
  etoken?: string;
  source?: TuvisMessageSource;
  throwOnFailure?: boolean;
};

/**
 * Structural type for the `MediaStreamer` class in the commons media-streamer module.
 * `types` consumers use `MediaStreamer` only as a type (`InstanceType<typeof MediaStreamer>`),
 * so the public instance shape lives here as the single source of truth. The concrete class
 * in `commons` is assignable to this interface.
 */
export interface MediaStreamerInterface {
  streamMediaToIngest(data: SidecarWebhookCommands & { command: "report_media_message" }, options: StreamMediaToIngestOptions): Promise<void>;
}
